module.exports = __webpack_public_path__ + "img/t2.ea49a8b4.jpg";